import { ReactNode } from "react";
import Alert, { AlertColor } from "@mui/material/Alert";
import Button from "@mui/material/Button";

interface StatusTaskBannerProps {
  /** จำนวนใบที่ค้าง มาจาก summary ของ API ไม่ใช่การนับแถวในหน้า */
  count: number;
  /** กำลังกรองเฉพาะสถานะนี้อยู่หรือไม่ */
  showingOnly: boolean;
  onToggleShowingOnly: () => void;
  severity: AlertColor;
  children: ReactNode;
}

/**
 * แถบงานค้างของ HO ใน W1 (ยังไม่ระบุสาขา / สาขาส่งคืน) ซึ่งอยู่เหนือแถบสรุปสถานะ
 *
 * กดเพื่อกรองเฉพาะใบกลุ่มนั้น กดซ้ำเพื่อดูทั้งหมด · ไม่แสดงอะไรเลยเมื่อไม่มีใบค้าง
 * (คู่กับ UnmatchedBanner ของ W7 ที่เตือนงานค้างของสาขา)
 */
export default function StatusTaskBanner({
  count,
  showingOnly,
  onToggleShowingOnly,
  severity,
  children,
}: StatusTaskBannerProps) {
  if (count === 0) return null;

  return (
    <Alert
      severity={severity}
      sx={{ mb: 2 }}
      action={
        <Button color="inherit" size="small" onClick={onToggleShowingOnly}>
          {showingOnly ? "ดูทั้งหมด" : "ดูเฉพาะที่ค้าง"}
        </Button>
      }
    >
      {children}
    </Alert>
  );
}
